import { render } from "./MultiVideo.vue?vue&type=template&id=a3464bc4&scoped=true"
import script from "./MultiVideo.vue?vue&type=script&lang=js"
export * from "./MultiVideo.vue?vue&type=script&lang=js"

import "./MultiVideo.vue?vue&type=style&index=0&id=a3464bc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3464bc4"]])

export default __exports__